import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInformation = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "currentColor",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M2 1.5h-.5v13h13v-13H2Zm.5 12v-11h11v11h-11Zm2.3-5.4h6.4v-1H4.8v1Zm6.4-2.4H4.8v-1h6.4v1Zm-6.4 4.8H8v-1H4.8v1Z",
		clipRule: "evenodd"
	})
});
export default SvgInformation;
